import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ISignature, ICreateSignaturePayload, IUpdateSignaturePayload } from '../models/account.models';

// ─────────────────────────────────────────────────────────────────────────────
// SignatureService
// ─────────────────────────────────────────────────────────────────────────────
// CRUD operations for mailbox signatures.
// All endpoints are scoped under /v1/inbox/mailboxes/{mailboxId}/signatures.
// ─────────────────────────────────────────────────────────────────────────────

@Injectable({ providedIn: 'root' })
export class SignatureService {

  private baseUrl = environment.BASE_URL_API + 'inbox/mailboxes';

  constructor(private http: HttpClient) {}

  // ── CRUD ───────────────────────────────────────────────────────────────────

  list(mailboxId: number): Observable<{ data: ISignature[] }> {
    return this.http.get<{ data: ISignature[] }>(
      `${this.baseUrl}/${mailboxId}/signatures`,
    );
  }

  get(mailboxId: number, signatureId: number): Observable<{ object: ISignature }> {
    return this.http.get<{ object: ISignature }>(
      `${this.baseUrl}/${mailboxId}/signatures/${signatureId}`,
    );
  }

  create(mailboxId: number, payload: ICreateSignaturePayload): Observable<{ object: ISignature; message: string }> {
    return this.http.post<{ object: ISignature; message: string }>(
      `${this.baseUrl}/${mailboxId}/signatures`,
      payload,
    );
  }

  update(mailboxId: number, signatureId: number, payload: IUpdateSignaturePayload): Observable<{ object: ISignature; message: string }> {
    return this.http.patch<{ object: ISignature; message: string }>(
      `${this.baseUrl}/${mailboxId}/signatures/${signatureId}`,
      payload,
    );
  }

  delete(mailboxId: number, signatureId: number): Observable<{ object: { success: boolean; message: string }; message: string }> {
    return this.http.delete<{ object: { success: boolean; message: string }; message: string }>(
      `${this.baseUrl}/${mailboxId}/signatures/${signatureId}`,
    );
  }
}
